import React from 'react';

const PlusIcon = ({ width = "10", height = "10", className}) => (
  <svg className={className} width={width} height={height} viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M16,9 C16,7.89543 16.8954,7 18,7 C19.1046,7 20,7.89543 20,9 L20,14 L25,14 C26.1046,14 27,14.8954 27,16 C27,17.1046 26.1046,18 25,18 L20,18 L20,23 C20,24.1046 19.1046,25 18,25 C16.8954,25 16,24.1046 16,23 L16,18 L11,18 C9.89543,18 9,17.1046 9,16 C9,14.8954 9.89543,14 11,14 L16,14 L16,9 Z"
      fill="currentColor"
    />
  </svg>
);

export default PlusIcon;
